<template>
    <div class="slider">
        <b-container fluid>
            <b-row>
                <b-col md="12" class="text-center mb-4">
                    <h1>{{ title }}</h1>
                </b-col>
                <b-col>
                    <VueSlickCarousel v-bind="slickOptions" :arrows="false" :dots="true">
                        <div v-for="item in data" :key="item">
                            <img :src="item" class="img-fluid" alt="">
                        </div>
                    </VueSlickCarousel>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        components: {
            VueSlickCarousel
        },
        data() {
            return {
                slickOptions: {
                    autoplay: true,
                    infinite: true,
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    speed: 1000,
                    responsive: [
                        {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1
                        }
                        },
                        {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                        },
                        {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                        }
                    ]
                },
            }
        },
        props: {
            data: {
                type: Array,
                required: true
            },
            title: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>
.slider{
    padding: 10% 5%;
}

@media (max-width: 1600px){
  h1{
    font-size: 45px;
  }
}

@media (max-width: 768px){
  h1{
    font-size: 35px;
  }
  .slider{
        padding: 15% 5%;
    }
}
</style>